<div class="separador"> </div>

<div class="d-flex" id="wrapper">
    <!-- Sidebar -->
    <div class="navbar-light bg-light border-right" id="sidebar-wrapper">
      <div class="sidebar-heading">{{fecdia | date: 'dd/MM/yyyy'}}</div>
      <div class="sidebar-heading"></div>
      <div class="sidebar-heading"></div>
      <div class="list-group list-group-flush">
        <a class="list-group-item list-group-item-action bg-light"
                 [routerLink]="mnu.ruta"  
              *ngFor="let mnu of menu; let i=index">
              <fa-icon [icon]="mnu.icono"></fa-icon> 
             {{mnu.nombre}}
        </a>
      </div>
    </div>
    <!-- /#sidebar-wrapper -->
    <!-- Page Content -->
    <div id="page-content-wrapper">
        <nav class="navbar navbar-expand-lg navbar-light bg-cave border-bottom">
                <button class="btn  btn-light" (click)="persiana()" id="menu-toggle"><span class="navbar-toggler-icon"></span></button>
                <span class="usuario">{{nomusu}} </span>         
                <div class="ml-auto">
                    <button class="btn btn-cave" (click)="listado()">
                        <fa-icon [icon]="icoVal"></fa-icon> Listar
                    </button>
                </div>          
        </nav>
        <div class="container-fluid">
              <div class="titular">
                  <h1>Ficha de Capital</h1>
                 <hr>
              </div>
              <div class="sellista">
                  <h3 class="display-6 tiplista" >Formato de Datos</h3>
                  <div class="custom-control custom-radio">
                      <input type="radio" class="custom-control-input" id="detalle" name="tipolista" (click)="modos(1)" [checked]="SwDetal">
                      <label class="custom-control-label" for="detalle">Detallado</label>
                  </div>
                     
                  <div class="custom-control custom-radio">
                      <input type="radio" class="custom-control-input" id="total" name="tipolista"  (click)="modos(2)"[checked]="SwTotal">
                      <label class="custom-control-label" for="total">Totales</label>
                  </div>     
              </div>     
              <div class="separador"> </div>
              <div class="separador"> </div>
              <div class="sellista">
                  <h3 class="display-6 tiplista" >Tipo de Listado</h3>
                  <div class="custom-control custom-radio">
                       <input type="radio" class="custom-control-input" id="lista" name="formalista" (click)="formas(0)" [checked]="SwLista">
                       <label class="custom-control-label" for="lista">Listado</label>
                  </div>
                  <div class="custom-control custom-radio">
                       <input type="radio" class="custom-control-input" id="impre" name="formalista"  (click)="formas(1)" [checked]="SwImpre">
                       <label class="custom-control-label" for="impre">Imprimir/PDF</label>
                  </div>          
                 <div class="custom-control custom-radio">
                     <input type="radio" class="custom-control-input" id="excel" name="formalista" (click)="formas(2)" [checked]="SwExcel">
                    <label class="custom-control-label" for="excel">Hoja Excel</label>
                 </div>
              </div>
              <hr/>
              <div class="separador"> </div>
             
              <div style="text-align: center;">
                    <div *ngIf="resul" class="spinner-border text-primary" role="status"></div>
              </div>
        </div>
    </div>
    <!-- /#page-content-wrapper -->
</div>
  

